export default __webpack_public_path__ + "static/media/42_photo.c5ebbc55.jpg";